import { useMemo } from 'react';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { type Permission, PermissionCode, User } from 'types';

/**
 * @deprecated use useHasPermissions hook instead
 */
export function checkUserPermissions(user: User, permissions: PermissionCode[]) {
  const userRoles = user.roles || [];

  const userRolePermissions = userRoles.reduce<Permission[]>((res, role) => {
    return role.permissions ? [...res, ...role.permissions] : res;
  }, []);

  const userPermissions = userRolePermissions.map((permission) => permission.code);

  return permissions.every(
    (permissionToCheck) => userPermissions.includes(permissionToCheck),
  );
}

export const useHasPermissions = ({ permissions }: { permissions: PermissionCode[] }) => {
  const { user } = useCurrentUser()

  const permitted = useMemo(() => {
    if (!user) {
      return
    }
    return checkUserPermissions(
      user,
      permissions,
    )
  }, [user, permissions]);

  return { permitted, checking: permitted === undefined }
}
